import React from "react";
import { useEffect, useState } from "react";
import { Box, Button, Grid, Rating, Typography } from "@mui/material";
import { Card } from "antd";
import { useNavigate } from "react-router-dom";
import ProductCard from "./ProductCard";

let para =
  "Lorem ipsum dolor sit amet consectetur adipisicing elit.Quibusdam aliquid pariatur quae a, dolor distinctio,repudiandae deserunt porro magni nulla quo fugit mollitiaplaceat nemo nihil quaerat tempore voluptatem sint.";

const ColorVariationsCard = ({ item, type }) => {
  const [selectedType, setselectedType] = useState("");
  const navigate = useNavigate();
  let image =
    item?.variations[0]?.images?.featuredImage?.src ||
    "https://navkarenterprises.co.in/wp-content/uploads/2022/03/14a.jpg";

  const [featuredImage, setfeaturedImage] = useState(image);

  return (
    <ProductCard
      item={item}
      children={
        <>
          Colors :
          {item.variations.map((el) => (
            <button
              key={el._id}
              style={{
                background: el.color,
                width: "20px",
                height: "20px",
                borderRadius: "50%",
                border: selectedType == el.color ? "3px solid black" : "none",
              }}
              onClick={() => {
                setselectedType(el.color);
                setfeaturedImage(el?.images?.featuredImage?.src);
              }}
            ></button>
          ))}
        </>
      }
    />
  );
};

export default ColorVariationsCard;
{
  /**  <Grid item xs={3} key={item._id + "imde"}>
      <Card
        border={"1px solid red"}
        onClick={() => navigate("/single-product/" + item._id)}
      >
        <img
          src={featuredImage}
          style={{
            width: "full",
            height: "300px",
            objectFit: "cover",
            objectPosition: "center",
          }}
          alt="x"
        />
        <br />
        <Typography variant="h6">{item.name}</Typography>
        <p
          dangerouslySetInnerHTML={{
            __html: item?.shortDescription?.substring(0, 80) + "...",
          }}
        ></p>
        <Typography sx={{ fontSize: "20px", fontWeight: "600" }}>
          ₹ {price || "NA"} &nbsp;&nbsp;&nbsp; <span>{originalPrice}</span>
        </Typography>
        <Rating
          value={
            item?.reviews?.reduce((acc, el) => acc + el.rating, 0) /
            item?.reviews?.length
          }
          readOnly
        />
        <div
          style={{
            height: "30px",
            display: "flex",
            gap: "5px",

            alignItems: "center",
            margin: "10px 0px",
          }}
        >
         
        </div>
        <Box
          style={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            gap: 3,
          }}
        >
           <Button variant="outlined" border={"1px solid #ddd"}>
            Add to Cart
          </Button> 
          </Box>
          </Card>
        </Grid> */
}
